import { RDnGaineCirculaire_Type } from '@batical/types/src'
import { fetchGeneric, fetchGenericSorted } from './GenericQ'

const DnGaineEuroventCirculaire: Array<RDnGaineCirculaire_Type> = require('../json/DnGaineEurovent_Circulaire.json')
//RPerteChargeAccident
export function fetchDnGaineCirculaireSorted(): Array<{ value: string; label: string }> {
  return fetchGenericSorted(DnGaineEuroventCirculaire)
}

export function fetchDnGaineCirculaire(uuid: string): RDnGaineCirculaire_Type {
  return fetchGeneric(DnGaineEuroventCirculaire, uuid)
}

export function fetchDnGaineCirculaireDiametreInferieur(section: number): RDnGaineCirculaire_Type | null {
  const res = DnGaineEuroventCirculaire.filter((item: RDnGaineCirculaire_Type) => item.diam_int >= section).sort(
    (a, b) => a.diam_int - b.diam_int
  )

  if (res.length > 0) {
    return res[0]
  }
  return null
}

// export function fetchDnGaineAroundCirculaire(diam_int: number): Array<{ diam: number, grand: number, petite:number }> {
//   let data : Array<{ diam: string, grand: number }> = [];
//   let res = DnGaineEuroventCirculaire.filter((item: RDnGaineRectangulaire_Type) =>
//     item.diam_int < diam_int
//   ).sort((a, b) => (a.diam_int - b.diam_int))

//   res.slice(res.length - 5, res.length - 1).forEach(child =>
//     {data.push({ diam: child.diam_int, grand: child.grand_cote, petite: child.petite_cote });}
//   );

//   res = DnGaineEuroventCirculaire.filter((item: RDnGaineCirculaire_Type) =>
//     item.diam_int === diam_int
//   )
//   res.forEach(child => {
//     data.push({ diam: child.diam_int, grand: child.grand_cote, petite: child.petite_cote });
//   });

//   res = DnGaineEuroventCirculaire.filter((item: RDnGaineCirculaire_Type) =>
//     item.diam_int > 0
//   ).sort((a, b) => (a.diam_int - b.diam_int))
//   res.slice(0, 5).forEach(child => {
//     data.push({ diam: child.diam_int, grand: child.grand_cote, petite: child.petite_cote });
//   });
//   return data;
// }
